module.exports = __webpack_public_path__ + "img/5.a24f9252.png";